import type {
  CompanyOfficeListResponse,
  GetCompanyOfficesParams,
} from '@/api/types/offices'
import { getMergableConfig, stringifyParams } from '@/lib/helpers'

import { sliceApi } from './api'

const OFFICE_TAGS = {
  COMPANY_OFFICE: 'CompanyOffice',
  COMPANY_OFFICES: 'CompanyOffices',
}

const getTagId = ({ id: office, company }) => `${office}-${company}`

const officesSliceApi = sliceApi
  .enhanceEndpoints({
    addTagTypes: [OFFICE_TAGS.COMPANY_OFFICE, OFFICE_TAGS.COMPANY_OFFICES],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCompanyOffices: builder.query<
        CompanyOfficeListResponse,
        GetCompanyOfficesParams
      >({
        query: (params) => ({
          url: `/admin/rmc/companies/offices${stringifyParams(params)}`,
          method: 'GET',
        }),
        providesTags: (result) => [
          OFFICE_TAGS.COMPANY_OFFICES,
          ...(result?.items || []).map(({ company, id }) => ({
            type: OFFICE_TAGS.COMPANY_OFFICE,
            id: getTagId({ id, company }),
          })),
        ],
        ...getMergableConfig(),
      }),
    }),
  })

export const { useGetCompanyOfficesQuery, useLazyGetCompanyOfficesQuery } =
  officesSliceApi
